// import React, { useEffect } from 'react';

// import { Fancybox as NativeFancybox } from '@fancyapps/ui';
// import '@fancyapps/ui/dist/fancybox/fancybox.css';

// function Fancybox(props) {
//   const delegate = props.delegate || '[data-fancybox="gallery"]';

//   useEffect(() => {
//     const opts = props.options || {};

//     NativeFancybox.bind(delegate, opts);

//     return () => {
//       NativeFancybox.destroy();
//     };
//   }, [delegate, props.options]); // Include 'delegate' and 'props.options' in the dependency array

//   return <>{props.children}</>;
// }

// export default Fancybox;

// Fancybox.jsx (unchanged, but you'll import NativeFancybox directly in UserPosts instead of using this wrapper multiple times)
import React, { useEffect } from 'react';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

function Fancybox(props) {
  const delegate = props.delegate || '[data-fancybox="gallery"]';

  useEffect(() => {
    const opts = props.options || {};

    NativeFancybox.bind(delegate, opts);

    return () => {
      NativeFancybox.destroy();
    };
  }, [delegate, props.options]);

  return <>{props.children}</>;
}

export default Fancybox;